import { PureComponent } from 'react';
import PropTypes from 'prop-types';

import styles from './SelectableItem.scss';

import { getDisplayName } from '~/utils';

export const selectableItem = (Item) =>
  class extends PureComponent {
    static displayName = `Selectable(${getDisplayName(Item)})`;

    static propTypes = {
      onChange: PropTypes.func,
      isChecked: PropTypes.bool.isRequired,
      isDisabled: PropTypes.bool,
      propName: PropTypes.string.isRequired,
      type: PropTypes.string,
    };

    static defaultProps = {
      onChange: null,
      isDisabled: null,
      type: null,
    };

    onChange = () => {
      const { isChecked, propName, [propName]: item, onChange } = this.props;

      onChange(isChecked ? null : item);
    };

    render() {
      const { propName, onChange, isDisabled, type, ...clearProps } = this.props;
      const {
        [propName]: { id },
        isChecked,
      } = clearProps;
      const classNames = `${styles.selectableItem} ${isChecked ? styles.checked : ''} ${isDisabled ? styles.disabled : ''}`;
      const disabledAttr = isDisabled ? { disabled: 'disabled' } : '';

      return (
        <div className={styles.wrapper}>
          <Item isDisabled={isDisabled} {...clearProps} />
          <label className={classNames} htmlFor={id}>
            <input
              type={type || 'checkbox'}
              id={id}
              className={styles.hiddenCheckbox}
              checked={isChecked}
              onChange={onChange ? this.onChange : null}
              readOnly={!onChange}
              name={`name_${id}`}
              {...disabledAttr}
            />
            <span className={styles.fakeInput} />
          </label>
        </div>
      );
    }
  };
